var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 67,
    viewBox: "0 0 50 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1972_429",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 67
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3646 15.0793L41.3716 15.0783L41.3787 15.0772C41.5183 15.0551 41.6612 15.0882 41.7769 15.1695C41.8899 15.249 41.9684 15.3683 41.9968 15.5033L48.2485 53.5966L26.6709 65.5174L26.6571 65.5251L26.6435 65.5331C26.1294 65.8387 25.5425 66 24.9445 66C24.3465 66 23.7595 65.8387 23.2455 65.5331L23.2345 65.5266L23.2233 65.5203L1.94473 53.5988L10.1046 1.89629C10.119 1.81584 10.1507 1.73943 10.1974 1.6723C10.2412 1.60941 10.2971 1.55607 10.3619 1.51542C10.4789 1.45939 10.6129 1.44896 10.7376 1.48664C10.8678 1.52603 10.9775 1.61481 11.0431 1.73396C11.0434 1.73461 11.0438 1.73525 11.0441 1.7359L19.5486 17.5571L20.4503 19.2345L21.3193 17.54L24.6461 11.0526L24.6559 11.0335L24.6649 11.0139C24.6955 10.9473 24.749 10.8939 24.8156 10.8632L24.8318 10.8558L24.8477 10.8478C24.9042 10.8193 24.9658 10.8025 25.0289 10.7982C25.092 10.794 25.1553 10.8024 25.2151 10.8231C25.2749 10.8437 25.3299 10.8761 25.377 10.9184C25.424 10.9607 25.4621 11.0119 25.489 11.0692L25.4983 11.0888L25.5084 11.1081L31.6631 22.8472L32.2945 24.0514L33.2559 23.09L41.1216 15.2243L41.1377 15.2082L41.1531 15.1913C41.2085 15.1306 41.2833 15.091 41.3646 15.0793Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1972_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2219 33.7181L20.3581 17.0837L0.848389 54.1309L29.2219 33.7181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.848389 54.1307L9.14182 1.85122C9.15318 1.64565 9.20682 1.44464 9.29939 1.26074C9.39196 1.07685 9.52146 0.914017 9.67981 0.782434C9.83815 0.650852 10.0219 0.553343 10.2197 0.496003C10.4174 0.438663 10.6248 0.422723 10.829 0.449181C11.0568 0.485396 11.2726 0.575438 11.4586 0.711828C11.6446 0.848218 11.7954 1.02702 11.8984 1.23337L20.4294 17.0836L23.8038 10.6674C23.8878 10.4864 24.0071 10.324 24.1548 10.1897C24.3025 10.0555 24.4755 9.9521 24.6637 9.88567C24.8519 9.81925 25.0514 9.79113 25.2507 9.80296C25.4499 9.81478 25.6447 9.86632 25.8237 9.95454C26.1028 10.0914 26.3285 10.3171 26.4653 10.5962L49.3257 54.1069L0.848389 54.1307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-11.1521 -2.5686H61.4213V70.0286H-11.1521V-2.5686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0517 55.4435L50.9766 54.9319L50.8061 53.8888L44.4613 15.0832L44.458 15.0634L44.4542 15.0437C44.3058 14.2671 43.8611 13.5787 43.2142 13.1241C42.5702 12.6715 41.776 12.4861 40.9984 12.6063C40.3609 12.7004 39.7742 13.0073 39.3336 13.4768L-0.212908 53.0708L-1.61211 54.4717L0.115224 55.4395L21.9858 67.6927C22.8821 68.2212 23.9037 68.5001 24.9445 68.5001C25.9838 68.5001 27.004 68.222 27.8993 67.6949L50.0517 55.4435Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.2496 66.06C26.568 66.418 25.8096 66.6051 25.0396 66.6051C24.2697 66.6051 23.5113 66.418 22.8296 66.06L1.10986 53.7981V54.1308L22.996 66.3927C23.6691 66.7898 24.4363 66.9993 25.2178 66.9993C25.9994 66.9993 26.7666 66.7898 27.4397 66.3927L49.611 54.1308V53.7981L27.2496 66.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9809 15.3252C42.9056 14.9312 42.68 14.5819 42.3518 14.3513C42.0236 14.1207 41.6186 14.0268 41.2224 14.0895C40.9117 14.1341 40.6261 14.2853 40.4145 14.5172L32.5488 22.3829L26.394 10.6438C26.3103 10.4656 26.1917 10.3061 26.0453 10.1745C25.8989 10.0429 25.7275 9.94207 25.5415 9.87783C25.3554 9.81359 25.1583 9.78729 24.9619 9.80048C24.7655 9.81367 24.5737 9.86609 24.3979 9.95464C24.1143 10.085 23.8867 10.3126 23.7563 10.5963L20.4294 17.0837L11.9221 1.25723C11.7309 0.906476 11.4094 0.645044 11.0269 0.529433C10.6445 0.413823 10.232 0.453318 9.87848 0.639385C9.6793 0.754643 9.50792 0.912322 9.3765 1.10124C9.24508 1.29015 9.15685 1.50567 9.11805 1.7325L0.848389 54.1308L22.7345 66.3927C23.4031 66.7902 24.1666 67 24.9445 67C25.7224 67 26.4858 66.7902 27.1545 66.3927L49.3495 54.1308L42.9809 15.3252Z",
    fill: "url(#paint0_linear_1972_429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2403 1.5284L31.2945 -0.473833L29.0398 -0.66507L-11.0253 -4.06324L-12.6521 -4.20121V-2.5686V70.0286V74.5054L-9.9549 70.9323L2.04562 55.0346L2.11896 54.9374L2.17568 54.8297L30.2403 1.5284Z",
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1972_429",
    x1: -0.434835,
    y1: 12.2122,
    x2: 50.1099,
    y2: 62.7569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.86e572c3cfc013d91463d90aebe5cc8d.svg";
export { ForwardRef as ReactComponent };